var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xtc-rules-container"},[_c('div',{staticClass:"page-content"},[_c('ul',_vm._l((_vm.ruleList),function(item,index){return _c('li',{key:index},[_vm._v(_vm._s(index+1)+". "+_vm._s(item))])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }